<template>
  <div class="body">
    <div class="title">
      <span class="title-1">{{ $t("paramSelect.currentCategory") }}: </span>
      <span class="title-2">{{ $commonUtil.getCatName(baseCategory, 'catName', 'catEnName') }} >
        {{ $commonUtil.getCatName(category, 'catName', 'catEnName') }}</span>
      <span class="title-3">
        <el-button @click="initStatus">{{ $t("paramSelect.reset") }}</el-button>
        <el-button @click="submit">{{ $t("paramSelect.screen") }}</el-button>
      </span>
    </div>
    <div class="box-outside">
      <div
        v-for="(item, index) in data"
        :key="index"
        class="el-transfer-panel"
      >
        <div class="el-transfer-panel__header">
          <label class="item-box">
            <div class="field">
              {{ $translate(category, item.field) }}
            </div>
            <div class="counter">{{ checked[item.field].length }}/{{ item.values.length }}</div>
          </label>
        </div>

        <div class="el-transfer-panel__body">
          <el-checkbox-group
            v-model="checked[item.field]"
            class="el-transfer-panel__list"
            style="display: flex;flex-direction: column"
          >
            <el-checkbox
              v-for="(value, i) in item.values"
              :key="index + '-' + i"
              :label="$translate(category, value)"
              :disabled="disabled[item.field][value]"
              @change="aggCheck"
            />
          </el-checkbox-group><p
            class="el-transfer-panel__empty"
            style="display: none;"
          >
            {{ $t("paramSelect.noMatchedData") }}
          </p><p
            class="el-transfer-panel__empty"
            style="display: none;"
          >
            {{ $t("paramSelect.noData") }}
          </p>
        </div><!---->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectBox",
  props: {
    category: {
      type: Object,
      default: null,
    },
    baseCategory: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      data: [],
      disabled: {},
      checked: {},
    }
  },
  watch: {
    category: {
      handler(newVal,oldVal){
        this.initData();
        this.submit();
      },
    },
    // baseCategory: {
    //   handler(newVal,oldVal){
    //     this.initData();
    //     this.submit();
    //   },
    // }
  },
  created() {
    this.initData();
  },methods: {
    initData() {
      this.data = [];
      this.disabled = {};
      this.checked = {};
      let url = "/select/prod/getSelectItemsByCat";
      let params = {
        category: this.category.catName,
        baseCategory: this.baseCategory.catName
      }
      this.$doPost(url, params).then(res=> {
        if (res.code === 200) {
          this.data = res.data;
          this.initStatus();
        }
      });
    },
    initStatus() {
      this.data.forEach(item =>{
        // 初始化选中状态--全部为空
        let key = item.field;
        this.$set(this.checked, key, []);
        // 初始化设置禁用状态--全部不禁用
        let disableStatus = {};
        item.values.forEach(value => {
          disableStatus[value] = false;
        });
        this.$set(this.disabled, key, disableStatus);
      });
    },
    initDisabled(bool) {
      this.data.forEach(item =>{
        let key = item.field;
        // 初始化设置禁用状态--全部不禁用(bool = false) / 全部禁用(bool = true)
        let disableStatus = {};
        item.values.forEach(value => {
          disableStatus[value] = bool;
        });
        this.$set(this.disabled, key, disableStatus);
      });
    },
    aggCheck() {
      let len = 0;
      for (let key in this.checked) {
        len += this.checked[key].length;
      }
      if (len === 0) {
        // 未选中任何参数，初始化选型框状态
        this.initStatus();
        return;
      }
      let url = "/select/prod/paramsSetAsh"
      let params = {
        baseCategory: this.baseCategory.catName,
        category: this.category.catName,
        data: this.checked
      }
      this.$doPost(url, params, true).then(res => {
        if (res.code !== 200) { return;}
        if (res.data == null) { return;}
        // 请求成功，全部改为禁用
        this.initDisabled(true);
        let acts = res.data;
        for ( let key in this.disabled) {
          // 如果没有这一列的聚合结果，该列的disabled全部为false
          if (!acts.hasOwnProperty(key)) {
            for (let value in this.disabled[key]) {
              this.disabled[key][value] = false;
            }
            continue;
          }
          // 将返回的参数改为可用，同时对已经选中的条件也不置灰
          for(let value in this.disabled[key]) {
            if (acts[key].indexOf(value) !== -1 || this.checked[key].indexOf(value) !== -1) {
              this.disabled[key][value] = false;
            }
          }
        }
      })

    },
    submit() {
      this.$emit("submit", this.checked)
    },
  }
}
</script>

<style scoped lang="less">
.body {
  border: 1px rgb(150, 150, 150) solid;
  border-radius: 8px;
  background: white;
  width: 1200px;
  margin: 0 auto;
  font-family: "微软雅黑", "Arial Black";
}
.title {
  margin: 30px;
  font-size: 20px;
  .title-2 {
    font-weight: bold;
    color: rgb(170, 180, 200)
  }
  .title-3 {
    float: right;
  }
}

.box-outside {
  margin: 20px 2%;
  width: 96%;
  overflow: scroll;
  display: flex;

}
.el-transfer-panel {
  overflow: visible;
  min-width: 200px;
  margin: 10px 5px 10px 5px;
}
.el-checkbox {
  line-height: 30px;
  height: 30px;
  margin-left: 10px;
}
/deep/ .el-button {
  font-size: 16px;
  background: #f5f7fa;
  color: black;
}
.field {
  font-size: 16px;
}
.counter {
  margin-right: 10px;
  font-size: 15px;
  color: #82848a;
  float: right;
}
.el-transfer-panel__header {
  height: fit-content;
}
.item-box {
  display: flex;
  justify-content: space-between;
}
</style>
